export const DEFAULT_TS_INPUT = "3h";
export const DEFAULT_TS_PARAM = "PT3H";
